import { Component, Input, OnInit } from "@angular/core";
import { Tournament } from "../../../../../shared/models/tournament";
import { TableType } from "../../../../../shared/enums/table-type";
import { TournamentStatus2 } from "../../../../../shared/enums/poker-types";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-view-tournament-mobile-status",
  templateUrl: "./view-tournament-mobile-status.component.html",
  styleUrls: ["./view-tournament-mobile-status.component.scss"],
})
export class ViewTournamentMobileStatusComponent implements OnInit {
  @Input() tournament: Tournament;
  showStatusBanner: boolean = false;

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.showStatusBanner =
      this.tournament?.tourSum?.Type !== TableType.SnG &&
      this.tournament?.tourSum?.Type !== TableType.SpinnGo;
  }

  public status = TournamentStatus2;

  get tournamentStatusInfo(): {
    label: string;
    value: null | Date;
  } {
    if (!this.tournament?.tourSum) {
      return { label: "Unknown", value: null };
    }

    switch (this.tournament.tourSum.Status2) {
      case this.status.Announced:
        return {
          label: "page.tournament.label.registrationOpens",
          value: this.tournament.tourSum._registrationsStartInDate,
        };

      case this.status.RegistrationOpen:
        return this.tournament.tourSum.StartIn > 0
          ? {
              label: "page.tournament.label.tournamentStarts",
              value: this.tournament.tourSum._startInDate,
            }
          : { label: "page.LABEL.TOURNAMENTSTARTINGSOON", value: null };

      case this.status.RunningWithLateRegistration:
        return {
          label: "page.tournament.label.lateRegistrationEndsIn",
          value: this.tournament.tourSum._lateRegistrationPeriodDate,
        };

      case this.status.RunningRegistrationClosed:
        return { label: "LABEL.RUNNINGTIME", value: null };

      case this.status.Completed:
        return { label: "LABEL.RUNNINGTIME", value: null };

      case this.status.Canceled:
        return { label: "LABEL.RUNNINGTIME", value: null };

      default:
        return { label: "", value: null };
    }
  }
}
